export default __webpack_public_path__ + "static/media/avatar.da247c9b.jpg";